(() => {
  const formatArticleContent = (scope) => {
    scope.querySelectorAll('[data-lumino-article-content]').forEach((content) => {
      content.querySelectorAll('h1').forEach((heading) => {
        const subheading = document.createElement('h2');
        [...heading.attributes].forEach((attribute) => subheading.setAttribute(attribute.name, attribute.value));
        subheading.append(...heading.childNodes);
        heading.replaceWith(subheading);
      });

      content.querySelectorAll('table').forEach((table) => {
        if (table.parentElement.classList.contains('lumino-article-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'lumino-article-table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || content.dataset.tableLabel);
        table.before(wrapper);
        wrapper.append(table);
      });

      content.querySelectorAll('p').forEach((paragraph) => {
        if (!paragraph.id && !paragraph.textContent.trim() && !paragraph.querySelector('a, img, picture, video, audio, iframe, object, embed, svg, canvas, input, button, [id]')) {
          paragraph.hidden = true;
        }
      });
    });
  };

  formatArticleContent(document);
  document.addEventListener('shopify:section:load', (event) => formatArticleContent(event.target));
})();
